const data = [
  {
    content:
      '<p class=\'cursive\'>Comme indiqué dans le texte, le meurtier a codé sa signature, la lettre "Q" n\'est donc pas réellement la dernière lettre de son nom et le texte parle de "signes cachés".</p>',
    read: false,
    display: false,
    vue: "dayOne",
    id: 1,
  },
  {
    content:
      "<p class='cursive'>Il y a une ligne invisible mais sélectionnable en bas de la lettre. Avec un copié/collé (dans le bloc notes par exemple), on découvre le code suivant :<br />331 723 646 822 561 615 117 442 245 124.</p>",
    read: false,
    display: false,
    vue: "dayOne",
    id: 2,
  },
  {
    content:
      "<p class='cursive'>La missive est composée de plusieurs lignes, chaque ligne est composée de plusieurs mots, et enfin chaque mot est composé de plusieurs lettres.</p>",
    read: false,
    display: false,
    vue: "dayOne",
    id: 3,
  },
  {
    content:
      '<p class=\'cursive\'>Chaque groupe de trois chiffres nous donne le numéro de la ligne à regarder, puis le numéro du mot dans cette ligne, et enfin le numéro de la lettre dans le mot. Ainsi "331" nous donne "3ème ligne, 3ème mot, 1ère lettre", soit le "C".</p>',
    read: false,
    display: false,
    vue: "dayOne",
    id: 4,
  },
  {
    content:
      "<p class='cursive'>Le décodage complet donne : \"Code César 3\". Le code César est une méthode de cryptage par décalage très simple et très ancienne. Si vous ne le connaissez pas, une recherche devrait vous aider. Il n'y a plus qu'a l'appliquer au bon élément !</p>",
    read: false,
    display: false,
    vue: "dayOne",
    id: 5,
  },
  {
    content:
      "<p class='cursive'>Il faut commencer par décrypter la liste des pays que nous donne Carmen. L'indice important est : \"c'est capital de chez capital\".</p>",
    read: false,
    display: false,
    vue: "dayTwo",
    id: 11,
  },
  {
    content:
      "<p class='cursive'>En prenant la première lettre (lettre capitale) de chaque capitale, on obtient le mot \"Navajo\". (Nouackchott – Apia – Vientiane – Accra – Jakarta – Ouagadougou)</p>",
    read: false,
    display: false,
    vue: "dayTwo",
    id: 12,
  },
  {
    content:
      '<p class=\'cursive\'>Le mot "Navajo" fait référence au "code Navajo" (aussi appelé "code talker") utlisé par l\'armée américaine durant la Seconde Guerre mondiale.</p>',
    read: false,
    display: false,
    vue: "dayTwo",
    id: 13,
  },
  {
    content:
      "<p class='cursive'>En utilisant le code Navajo pour décrypter les symboles rouges ont obtient le mot \"Digamma\". Ce mot devrait vous aider à trouver la lettre que l'on cherche.</p>",
    read: false,
    display: false,
    vue: "dayTwo",
    id: 14,
  },
  {
    content:
      "<p class='cursive'>La couleur des lettres teintées associée à la remarque de Carmen devrait vous mettre sur la bonne voie.</p>",
    read: false,
    display: false,
    vue: "dayThree",
    id: 21,
  },
  {
    content: "<p class='cursive'>Il s'agit des couleurs de l'arc-en-ciel.</p>",
    read: false,
    display: false,
    vue: "dayThree",
    id: 22,
  },
  {
    content:
      "<p class='cursive'>Une fois les couleurs remises dans le bon ordre on obtient le mot \"Gadsby\". C'est à priori le titre d'un roman, ce dernier vous donnera la lettre que l'on cherche.</p>",
    read: false,
    display: false,
    vue: "dayThree",
    id: 23,
  },
  {
    content:
      "<p class='cursive'>Il est question dans cette histoire d'un héros qui monte un cheval ailé (Pégase, peut-être ?), qui sauve une princesse qui devait être sacrifiée pour chasser un montre du royaume de ses parents (envoyé ici à cause des paroles de sa mère).</p>",
    read: false,
    display: false,
    vue: "dayFour",
    id: 31,
  },
  {
    content:
      "<p class='cursive'>Une recherche avec les mots-clés ci-dessus nous ramène au mythe d'Andromède.</p>",
    read: false,
    display: false,
    vue: "dayFour",
    id: 32,
  },
  {
    content:
      "<p class='cursive'>C'est la reine qui est au coeur de l'enquête et non sa fille, comme nous l'indique la première carte. Le personnage qui nous intéresse est donc Cassiopée.</p>",
    read: false,
    display: false,
    vue: "dayFour",
    id: 33,
  },
  {
    content:
      "<p class='cursive'>Il ne faut pas oublier que la réponse nous est apportée par la dernière carte : l'étoile.<br /> Cassiopée est le nom d'une constellation</p>",
    read: false,
    display: false,
    vue: "dayFour",
    id: 34,
  },
  {
    content:
      "<p class='cursive'>Il serait bon de commencer par jeter un oeil au recueil \"Histoires Extraordinaires\" et chercher la dernière nouvelle à être sortie.</p>",
    read: false,
    display: false,
    vue: "dayFive",
    id: 41,
  },
  {
    content:
      "<p class='cursive'>Il faut faire attention à l'année à laquelle nous nous trouvons. Nous sommes en 1843, la nouvelle qui nous intéresse est \"Le scarabée d'or\".</p>",
    read: false,
    display: false,
    vue: "dayFive",
    id: 42,
  },
  {
    content:
      "<p class='cursive'>La nouvelle parle de cryptologie. On y découvre le code du scarabée d'or.</p>",
    read: false,
    display: false,
    vue: "dayFive",
    id: 43,
  },
  {
    content:
      "<p class='cursive'>Le code du scarabée d'or nous permet de décrypter le message \"Nombre Imaginaire\". Si les mathématiques ne sont pas votre spécialité, une recherche devrait vous aider à savoir quelle est la lettre que l'on cherche.</p>",
    read: false,
    display: false,
    vue: "dayFive",
    id: 44,
  },
];
export default data;
